import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from '@mui/material'

export interface Props {
  applicantName: string
  value: boolean | null
  onChange: (value: boolean) => void
}

const LetterOfAuthorityRadioGroup = ({ applicantName, value, onChange }: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value === 'true')
  }

  return (
    <Stack spacing={2} direction="row" justifyContent="space-between">
      <FormControl>
        <FormLabel id="letter-of-authority-label">
          Does {applicantName} have a valid letter of authority that allows them to take
          out new tenancies in the company name?
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="letter-of-authority-label"
          name="letter-of-authority"
          value={value === null ? undefined : value.toString()}
          onChange={handleChange}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </FormControl>
    </Stack>
  )
}

export default LetterOfAuthorityRadioGroup
